import { render, staticRenderFns } from "./lion-coin.vue?vue&type=template&id=4658b5aa&scoped=true&"
import script from "./lion-coin.vue?vue&type=script&lang=js&"
export * from "./lion-coin.vue?vue&type=script&lang=js&"
import style0 from "./lion-coin.vue?vue&type=style&index=0&id=4658b5aa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4658b5aa",
  null
  
)

export default component.exports